import { render, staticRenderFns } from "./ExtraCoverage.vue?vue&type=template&id=0f36f859&scoped=true"
import script from "./ExtraCoverage.vue?vue&type=script&lang=js"
export * from "./ExtraCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f36f859",
  null
  
)

export default component.exports